import dayjs from '@/plugins/dayjs'
import type { Customer } from '@/types/customer'
import { generateCustomers } from './generators'

/** Hand-authored, fully-fleshed records used in profile/detail demos throughout the app. */
const notableCustomers: Customer[] = [
  {
    id: 'cus_notable_01',
    firstName: 'Ion',
    lastName: 'Popescu',
    phone: '0722345678',
    email: 'ion.popescu@gmail.com',
    city: 'București',
    status: 'active',
    channels: ['email', 'sms', 'whatsapp'],
    consentSummary: 'accepted',
    consentDate: dayjs().subtract(48, 'day').toISOString(),
    tags: ['VIP', 'Fidel'],
    lastInteractionAt: dayjs().subtract(2, 'day').toISOString(),
    createdAt: dayjs().subtract(210, 'day').toISOString(),
  },
  {
    id: 'cus_notable_02',
    firstName: 'Maria',
    lastName: 'Georgescu',
    phone: '0733456789',
    email: 'maria.georgescu@outlook.com',
    company: 'Salon Elite Beauty',
    jobTitle: 'Proprietar',
    city: 'Cluj-Napoca',
    status: 'active',
    channels: ['sms', 'whatsapp'],
    consentSummary: 'accepted',
    consentDate: dayjs().subtract(120, 'day').toISOString(),
    tags: ['Corporate', 'VIP'],
    lastInteractionAt: dayjs().subtract(5, 'day').toISOString(),
    createdAt: dayjs().subtract(400, 'day').toISOString(),
  },
  {
    id: 'cus_notable_03',
    firstName: 'Andrei',
    lastName: 'Vasilescu',
    phone: '0744567890',
    email: 'andrei.vasilescu@yahoo.com',
    city: 'Timișoara',
    status: 'active',
    channels: ['email'],
    consentSummary: 'partial',
    consentDate: dayjs().subtract(15, 'day').toISOString(),
    tags: ['Nou'],
    lastInteractionAt: dayjs().subtract(15, 'day').toISOString(),
    createdAt: dayjs().subtract(15, 'day').toISOString(),
  },
  {
    id: 'cus_notable_04',
    firstName: 'Elena',
    lastName: 'Dinu',
    phone: '0755678901',
    email: 'elena.dinu@gmail.com',
    company: 'Distrib Prod SRL',
    jobTitle: 'Manager achiziții',
    city: 'Iași',
    status: 'active',
    channels: ['email', 'whatsapp'],
    consentSummary: 'accepted',
    consentDate: dayjs().subtract(300, 'day').toISOString(),
    tags: ['B2B', 'Corporate', 'Recomandare'],
    lastInteractionAt: dayjs().subtract(1, 'day').toISOString(),
    createdAt: dayjs().subtract(500, 'day').toISOString(),
  },
  {
    id: 'cus_notable_05',
    firstName: 'Bogdan',
    lastName: 'Stanciu',
    phone: '0766789012',
    email: 'bogdan.stanciu@gmail.com',
    city: 'Constanța',
    status: 'active',
    channels: [],
    consentSummary: 'none',
    tags: ['Risc de pierdere'],
    lastInteractionAt: dayjs().subtract(140, 'day').toISOString(),
    createdAt: dayjs().subtract(600, 'day').toISOString(),
  },
  {
    id: 'cus_notable_06',
    firstName: 'Cristina',
    lastName: 'Moldovan',
    phone: '0777890123',
    email: 'cristina.moldovan@gmail.com',
    company: 'Clinica DentalCare',
    jobTitle: 'Recepție',
    city: 'Brașov',
    status: 'active',
    channels: ['sms', 'email'],
    consentSummary: 'accepted',
    consentDate: dayjs().subtract(80, 'day').toISOString(),
    tags: ['Fidel'],
    lastInteractionAt: dayjs().subtract(8, 'day').toISOString(),
    createdAt: dayjs().subtract(250, 'day').toISOString(),
  },
  {
    id: 'cus_notable_07',
    firstName: 'Victor',
    lastName: 'Achim',
    phone: '0788901234',
    email: 'victor.achim@gmail.com',
    city: 'București',
    status: 'archived',
    channels: ['sms'],
    consentSummary: 'partial',
    consentDate: dayjs().subtract(500, 'day').toISOString(),
    tags: [],
    lastInteractionAt: dayjs().subtract(365, 'day').toISOString(),
    createdAt: dayjs().subtract(700, 'day').toISOString(),
  },
]

export const customersFixture: Customer[] = [...notableCustomers, ...generateCustomers(220)]

export function findCustomerById(id: string): Customer | undefined {
  return customersFixture.find((c) => c.id === id)
}
